if (!customElements.get('sembonia-size-charts')) {
  customElements.define('sembonia-size-charts', class extends HTMLElement {
    connectedCallback() {
      if (this.dialog) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'sembonia-chart-dialog';
      this.dialog.setAttribute('aria-label', 'Size Guide');
      this.dialog.setAttribute('data-lenis-prevent', '');
      const showDialog = () => {
        this.mobileDialog = window.semboniaMobileBaseline?.scrollLockDisabled === true;
        if (this.mobileDialog) {
          this.dialog.show();
          trapFocus(this.dialog, close);
        } else this.dialog.showModal();
      };
      const panel = document.createElement('div');
      panel.className = 'sembonia-chart-dialog__panel';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'sembonia-chart-dialog__close';
      close.setAttribute('aria-label', 'Close size guide');
      close.textContent = '×';
      panel.append(close);
      this.dialog.append(panel);
      document.body.append(this.dialog);
      this.querySelectorAll('a').forEach(link => link.setAttribute('aria-haspopup', 'dialog'));
      this.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const image = link.querySelector('img');
        if (!image) return;
        event.preventDefault();
        panel.querySelector('img')?.remove();
        const enlarged = image.cloneNode(true);
        enlarged.loading = 'eager';
        panel.append(enlarged);
        this.opener = link;
        showDialog();
        window.semboniaScrollLock.acquire(this.dialog);
        close.focus({ preventScroll: true });
      }, options);
      close.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('keydown', event => {
        if (this.mobileDialog && event.key === 'Escape') { event.preventDefault(); this.dialog.close(); }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      // Native dialog handles Escape and traps keyboard focus.
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        if (this.mobileDialog) removeTrapFocus();
        window.semboniaScrollLock.release(this.dialog);
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      window.addEventListener('sembonia:mobile-baseline-change', () => {
        if (!this.dialog.open || this.mobileDialog === (window.semboniaMobileBaseline?.scrollLockDisabled === true)) return;
        if (this.mobileDialog) removeTrapFocus();
        this.dialog.close();
        showDialog();
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog) {
        if (this.mobileDialog) removeTrapFocus();
        window.semboniaScrollLock.release(this.dialog);
        this.dialog.remove();
        this.dialog = null;
      }
    }
  });
}
